import { Directive, ElementRef, inject, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appSticky]',
  standalone: true,
})
export class StickyDirective {
  private element = inject(ElementRef);
  private renderer = inject(Renderer2);

  constructor() {
    this.renderer.setStyle(this.element.nativeElement, 'position', 'sticky');
    this.renderer.setStyle(this.element.nativeElement, 'top', '30px');
  }
}
